import { combineReducers } from "redux";
import AuthReducers from "./AuthReducers";
import SchoolReducers from "./SchoolReducers";
import GlobalReducers from "./GlobalReducers";
import AlertReducers from "./AlertReducers";
import StudentReducers from "./StudentReducers";
import PermissionReducer from "./PermissionReducer";
import CrossSchoolSearchReducer from "./CrossSchoolSearchReducer";
import InterviewReducer from "./InterviewReducer";
import AdminReducers from "./AdminReducers";
import ToggleReducer from "./ToggleReducer";

export default combineReducers({
  auth: AuthReducers,
  school: SchoolReducers,
  global: GlobalReducers,
  alerts: AlertReducers,
  student: StudentReducers,
  permissionStore: PermissionReducer,
  crossSchoolSearchStore: CrossSchoolSearchReducer,
  interview: InterviewReducer,
  admin: AdminReducers,
  toggles: ToggleReducer
});
